module.exports = __webpack_public_path__ + "media/images/ukrpol-in-numbers-en-dca8ec7358bbf7ef46b877831033850e.svg";